import { gql } from "@apollo/client";

export const CREATE_PROFESIONAL_EVALUACION = gql`
    mutation CreateEvaluacionProfesionales($input: AddProfesionalEvaluacionInput!, $idEvaluacion: Int!)
    {
        createEvaluacionProfesionales(input: $input, idEvaluacion: $idEvaluacion) 
        {
            idEvaluacionProfCP
            idEvaluacion
        }
    }
`;